import styled from 'styled-components';

export const StyledTextBtn = styled.button`
  cursor: pointer;
`;
